export const POSTAGE_REQUEST = 'POSTAGE_REQUEST';
export const POSTAGE_SUCCESS = 'POSTAGE_SUCCESS';
export const POSTAGE_GET_SUCCESS = 'POSTAGE_GET_SUCCESS';
export const POSTAGE_VALIDATION_ERROR = 'POSTAGE_VALIDATION_ERROR';
export const POSTAGE_REDIRECT_TO_LIST = 'POSTAGE_REDIRECT_TO_LIST';
export const HIDE_POSTAGE_FIELD_VALIDATION_ERROR = 'HIDE_POSTAGE_FIELD_VALIDATION_ERROR';

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

export const ACCOUNTS_SUCCESS = 'ACCOUNTS_SUCCESS';
export const ACCOUNTS_REQUEST = 'ACCOUNTS_REQUEST';

export const POSTAGE_ACCOUNTS_REQUEST = 'POSTAGE_ACCOUNTS_REQUEST';
export const POSTAGE_ACCOUNTS_SUCCESS = 'POSTAGE_ACCOUNTS_SUCCESS';
export const POSTAGE_ACCOUNT_GET_SUCCESS = 'POSTAGE_ACCOUNT_GET_SUCCESS';
export const POSTAGE_ACCOUNT_VALIDATION_ERROR = 'POSTAGE_ACCOUNT_VALIDATION_ERROR';
export const POSTAGE_ACCOUNT_REDIRECT_TO_LIST = 'POSTAGE_ACCOUNT_REDIRECT_TO_LIST';